import {ReactPlayer} from '@crema/modules/thirdParty';

export default ReactPlayer;
